module.exports = __webpack_public_path__ + "static/img/jdk02.0dc4712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/jdk02.png
// module id = WK9/
// module chunks = 37